import {
  PumpCommand,
  PumpCommandAutomate,
  PumpCommandMan,
  PumpState,
  type FullBoilerRoom,
  type Pumps,
} from "@eisox/api/core-api";

import { m } from "~/paraglide/messages";

export interface PumpsPermutationForm {
  permutationDay?: number;
  permutationHour?: number;
  pumpsPermutationDay?: number;
  pumpsPermutationHour?: number;
}

export const getPumpsPermutationFormValues = (
  boilerRoom?: Pick<
    FullBoilerRoom,
    "permutationDay" | "permutationHour" | "pumpsPermutationDay" | "pumpsPermutationHour"
  >,
): PumpsPermutationForm => ({
  permutationDay: boilerRoom?.permutationDay,
  permutationHour: boilerRoom?.permutationHour,
  pumpsPermutationDay: boilerRoom?.pumpsPermutationDay,
  pumpsPermutationHour: boilerRoom?.pumpsPermutationHour,
});

export const isOnlyOnePump = (pumps?: Pumps) => {
  // oxlint-disable typescript/no-unnecessary-condition -- null possible at runtime despite OpenAPI typing
  const conditionState =
    pumps?.stateP1 !== undefined && pumps.stateP1 !== null && pumps.stateP2 !== undefined && pumps.stateP2 !== null;
  const conditionDefect =
    pumps?.defectP1 !== undefined && pumps.defectP1 !== null && pumps.defectP2 !== undefined && pumps.defectP2 !== null;
  const conditionCommandMan =
    pumps?.commandManP1 !== undefined &&
    pumps.commandManP1 !== null &&
    pumps.commandManP2 !== undefined &&
    pumps.commandManP2 !== null;
  return !conditionState && !conditionDefect && !conditionCommandMan;
};

export const shouldDisplayPumpCommutator = (
  state?: PumpState,
  commandAutomate?: PumpCommandAutomate,
  commandMan?: PumpCommandMan,
  command?: PumpCommand,
) => {
  if (
    (state !== undefined &&
      commandAutomate !== undefined &&
      commandMan === PumpCommandMan.MANUAL &&
      command !== undefined) ||
    (state === undefined &&
      commandAutomate !== undefined &&
      commandMan === PumpCommandMan.MANUAL &&
      command !== undefined)
  ) {
    return true;
  }
  return false;
};

export const getPumpState = (
  state?: PumpState,
  commandAutomate?: PumpCommandAutomate,
  commandMan?: PumpCommandMan,
  defect?: boolean,
): { state: PumpState | PumpCommandAutomate | null; error?: string } => {
  if (defect) return { state: null };
  if (commandMan === PumpCommandMan.MANUAL) {
    if (state !== undefined) {
      return { state: state };
    }
    return {
      state: null,
      error: m.pumps_warning_1(),
    };
  }
  if (state !== undefined)
    return {
      state: state,
      error: commandMan === undefined ? m.pumps_warning_3() : undefined,
    };
  if (commandAutomate !== undefined)
    return {
      state: commandAutomate,
      error: commandMan === undefined ? m.pumps_warning_4() : m.pumps_warning_2(),
    };
  return {
    state: null,
    error: m.pumps_warning_5(),
  };
};

export const pumpsAutoManualOrForcing = (
  command?: PumpCommand,
  commandMan1?: PumpCommandMan,
  commandMan2?: PumpCommandMan,
): "auto" | "manual" | "forcing" | "unknown" => {
  if (commandMan1 && commandMan2 && commandMan1 !== commandMan2) {
    return "unknown";
  }
  if (commandMan1 === PumpCommandMan.MANUAL || commandMan2 === PumpCommandMan.MANUAL) {
    return "manual";
  } else {
    if (command && [PumpCommand.OFF, PumpCommand.PUMP_1, PumpCommand.PUMP_2].includes(command)) {
      return "forcing";
    }
    if (command === PumpCommand.AUTO) {
      return "auto";
    }
  }
  return "auto";
};
